import TemplateView from "../../TemplateView";
import CounterProgressBar from "./CounterProgressBar";
import Counter from "./Counter";
import {HIERARCHY_LEVEL_CLASSES} from "./constants";

export default class CounterWithProgressBar extends TemplateView {
    constructor({
        title = "",
        hierarchyLevel = "",
        pale = false,
        hasProgressBar = false
    }) {
        super();
        this.props = {
            title,
            hierarchyLevel,
            hasProgressBar
        }
        this.state = {
            all: false,
            curValue: 0,
            maxValue: 0,
            title: title,
            active: true,
            pale,
        };

        this.onAnyStatePropertyChanged(['all', 'curValue', 'maxValue', 'active', 'pale'], () => this._updateView())

        this.onStatePropertyChanged('title', title => this._updateTitle(title))
    }

    _updateView() {
        const counterValue = this.state.curValue;
        this.counter.setState({
            value: counterValue
        })

        const ratio = (this.state.maxValue !== 0) ? this.state.curValue / this.state.maxValue : 0;
        if (this.props.hasProgressBar) {
            this.progress.setState({
                ratio: (ratio <= 1) ? ratio : 1
            })
        }

        this.$el.toggleClass("inactive", !this.state.active);

        this.counter.setState({pale: this.state.pale})
    }

    _updateTitle(title) {
        this.$title.text(title)
    }

    templateHtml() {
        return "<div class='workAssignment_counter'>" +
               "   <div class='counterPlaceholder'/>" +
               "   <div class='title <%-hierarchyLevelClass%>'><%-title%></div>" +
               "   <div class='progressPlaceholder'/>" +
               "</div>";
    }

    templateModel() {
        return {
            hierarchyLevelClass: HIERARCHY_LEVEL_CLASSES[this.props.hierarchyLevel],
            title: this.props.title
        }
    }

    afterRender() {
        this.counter = new Counter({
            hierarchyLevel: this.props.hierarchyLevel,
        }).init(this.find('.counterPlaceholder'));

        if (this.props.hasProgressBar) {
            this.progress = new CounterProgressBar({
                hierarchyLevel: this.props.hierarchyLevel,
            }).init(this.find('.progressPlaceholder'));
        }

        this.$el.toggleClass("withoutTitle", this.props.title === "");

        this.$title = this.find('.title')

        this.renderInitialState()
    }
}



// WEBPACK FOOTER //
// ./web/js/components/counterCPT/CounterWithProgressBar.js